<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="!aba ? 'active' : ''" @click.prevent="abrir('')">
                        Pesquisa
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'config-filtros' ? 'active' : ''" @click.prevent="abrir('config-filtros')">
                        Filtros
                    </a>
                </li>

                <!--
                <li class="nav-item" v-if="false">
                    <a class="nav-link" href="#" :class="aba == 'filtros' ? 'active' : ''" @click.prevent="abrir('eventos')">
                        Eventos
                    </a>
                </li>
                <li class="nav-item" v-if="false">
                    <div class="btn-group dropleft">
                        <button class="btn btn-light dropdown-toggle" type="button" id="triggerId" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <i class="fas fa-ellipsis-h ml-2"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="triggerId">
                            <a class="dropdown-item" href="#" :class="aba == 'config-alertas' ? 'active' : ''" @click.prevent="abrir('config-alertas')">
                                Alertas 
                            </a>
                        </div>
                    </div>
                </li>
                -->
            </ul>
        </div>

        <pesquisa-livre ref="livre" :id_pesquisa_alerta="id_pesquisa_alerta" v-if="!aba" @criarfiltro="abrir('config-filtros')" />
        <pesquisa-alerta v-if="aba == 'config-filtros'" @pesquisar="pesquisar"/>
    </div>
</template>

<script>
import PesquisaAlerta from './PesquisaAlerta.vue';
import PesquisaLivre from './PesquisaLivre.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null, 
            id_pesquisa_alerta: null, 
        };
    },

    props: ['aba'],

    components: { 
        PesquisaAlerta,
        PesquisaLivre, 
    },

    methods: { 
        pesquisar (id) { 
            this.id_pesquisa_alerta = id;

            this.abrir('');

            this.$nextTick(() => {
                this.id_pesquisa_alerta = null;
            });
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
                this.$router.push({ path: '/pesquisa-clinica/' + aba });
            }
        },
    }
}
</script>